{
	"production": {
		"violationReportingHost": "change.my.salesforce-sites.com"
	},
	"staging": {
		"violationReportingHost": "change--service.sandbox.my.salesforce-sites.com"
	},
	"demo": {
		"violationReportingHost": "change--service.sandbox.my.salesforce-sites.com"
	},
	"development": {
		"violationReportingHost": "change--service.sandbox.my.salesforce-sites.com"
	}
}
